import api from "../../api/api";

export const uploadDoc = data => api.post("term/document-upload", data);
